import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import {
  bindPopover,
  bindTrigger,
  usePopupState,
} from 'material-ui-popup-state/hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import Button from './Button/Button';
import { ArrowRightIcon, BookIcon, ChevronDownIcon } from './icons';

function parseLinks(text) {
  if (!text) return {};
  const lines = text.split('\n');
  const grouped = {};
  let current = null;
  lines.forEach((line) => {
    if (!line.trim()) return;
    if (line.startsWith('/')) {
      grouped[line] = [];
      current = line;
    } else {
      const [title, url] = line.split('|').map((i) => i.trim());
      grouped[current].push({ title, url });
    }
  });
  return grouped;
}

function getLinksForPath(links, path) {
  const exact = links[path];
  if (exact) return exact;
  const keys = Object.keys(links);
  const key = keys.find((i) => path.startsWith(i) && i !== '/');
  return links[key];
}

const LearnMenu = () => {
  const [t] = useTranslation('common');
  const location = useLocation();
  const menuState = usePopupState({
    variant: 'popover',
    popupId: 'user',
  });
  const links = t('learn-links');

  const parsed = useMemo(() => parseLinks(links), [links]);

  const menuItems = useMemo(() => {
    const options = getLinksForPath(parsed, location.pathname);

    return options?.map((i, idx) => (
      <ListItemButton
        key={idx}
        sx={{ borderRadius: 0.8 }}
        component="a"
        target="_blank"
        to={i.url}
        onClick={() => menuState.close()}
      >
        <ListItemText
          primary={i.title}
          primaryTypographyProps={{
            fontWeight: 500,
          }}
          sx={{ mr: 2 }}
        />
        <ArrowRightIcon />
      </ListItemButton>
    ));
  }, [location.pathname, parsed]);

  if (!menuItems) return null;

  return (
    <>
      <Button
        rounded
        size="small"
        {...bindTrigger(menuState)}
        color="secondary"
        startIcon={<BookIcon />}
        endIcon={<ChevronDownIcon />}
      >
        Learn
      </Button>
      <Popover
        {...bindPopover(menuState)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={{ mt: 1 }}
      >
        <Box minWidth={260} maxWidth={350} px={1} py={2}>
          {menuItems}
        </Box>
      </Popover>
    </>
  );
};

export default LearnMenu;
